import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CssBaseline from "@material-ui/core/CssBaseline";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import MailIcon from "@material-ui/icons/Mail";
import { Box, Breadcrumbs } from "@material-ui/core";
import { Link, useLocation } from "react-router-dom";
import { AccountBalance } from "@material-ui/icons";
import * as menuItems from "./menuItems";
import HonariLogoIcon from "../../assets/images/honari_logo.png";
import { useCookies } from "react-cookie";
import axios from "axios";
import * as Constants from "../../constants/urls";
import Loading from "../Loading/Loading";
import SidebarView from "./SidebarView";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  title: {
    flexGrow: 1,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
}));

export default function Sidebar({ children }) {
  const location = useLocation();
  const currentPath = location.pathname;
  const [cookies, setCookie, removeCookie] = useCookies();
  const [login, setLogin] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  if (currentPath == "admin/orders" || currentPath == "/admin/orders") {
    window.location.href = Constants.panelUrl + "/order";
  }
  
  const handleDrawerOpen = () => {
    setIsOpen(!isOpen);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const withoutLayout = () => {
    if (
      currentPath == "/admin/excel" ||
      currentPath == "/admin/excel/" ||
      currentPath == "/admin/excel/index" ||
      currentPath == "/admin/excel/index/" ||
      currentPath == "/admin/excel/warehouse-receipt-tax-report" ||
      currentPath == "/admin/excel/warehouse-receipt-tax-report/" ||
      currentPath == "/admin/403" ||
      currentPath == "/admin/ag1" ||
      currentPath == "/admin/ag2" ||
      currentPath == "/admin/ag3" ||
      currentPath == "/admin/ag0"
    )
      return true;
    return false;
  };

  function auth() {
    const url = Constants.apiUrl + "/api/me";
    axios
      .get(url, {
        headers: {
          Authorization: "Bearer " + cookies.user_server_token,
        },
      })
      .then((r) => {
        console.log("me", r);

        setLogin(true);
      })
      .catch((e) => {
        if (currentPath != "/admin/403") {
          setLogin(false);

          window.location = "403";
        } else {
          setLogin(true);
        }
      });
  }

  useEffect(() => {
    auth();
    document.title = "پنل ادمین " + Constants.brandName;
  }, []);

  return (
    <>
      {login ? (
        <>
          {withoutLayout() ? (
            <>{children}</>
          ) : (
            <div className={classes.root}>
              <CssBaseline />
              <AppBar
                position="fixed"
                color=" "
                style={{ background: "#e9fbfb" }}
                className={clsx(classes.appBar, {
                  [classes.appBarShift]: isOpen,
                })}
              >
                <Toolbar>
                  <Typography variant="h6" noWrap className={classes.title}>
                    <b>پنل مدیریت {Constants.brandName}</b>
                  </Typography>

                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="end"
                    onClick={handleDrawerOpen}
                    className={clsx(isOpen)}
                  >
                    <MenuIcon />
                  </IconButton>
                </Toolbar>
              </AppBar>
              <main
                style={{ background: "#f1f2f7", minHeight: "100vh" }}
                className={clsx(classes.content, {
                  [classes.contentShift]: isOpen,
                })}
              >
                <div className={classes.drawerHeader} />
                <Box>{children}</Box>
              </main>
              <SidebarView isOpen={isOpen} />
            </div>
          )}
        </>
      ) : (
        <Loading />
      )}
    </>
  );
}
